import Skeleton from "react-loading-skeleton";
import { arrayMap } from "../../../../utils/array.utils";
import { stockListFormatter } from "../../../../utils/stockList.utils";
import VehicleInventoryAddButton from "./VehicleInventoryAddButton";
import VehicleInventoryView, { VehicleInventoryViewSkeleton } from "./VehicleInventoryView";
import { getRandomNumber } from "../../../../utils/number.utils";

export default function VehicleInventory({ data, loading, children }) {
  const formattedData = stockListFormatter(data);
  const inventory = formattedData?.inventory ?? [];

  return (
    <div>
      {children}
      <div className="row mt-0 g-3">
        {arrayMap(inventory, (item) => (
          <div className="col-12" key={item?.id}>
            <VehicleInventoryView data={item} />
          </div>
        )) || <VehicleInventoryAddButton data={data} />}
      </div>
    </div>
  );
}

// skeleton
export function VehicleInventorySkeleton() {
  return (
    <div>
      <Skeleton width={`${getRandomNumber(30, 60)}%`} />
      <div className="row mt-0 g-3">
        {arrayMap(Array(1).fill(0), (_, i) => (
          <div className="col-12" key={i}>
            <VehicleInventoryViewSkeleton />
          </div>
        ))}
      </div>
    </div>
  );
}
